var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4944_1865)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 0H2.66667C1.196 0 0 1.196 0 2.66667V10.6667C0 12.1373 1.196 13.3333 2.66667 13.3333H4.61533L7.11467 15.438C7.36933 15.664 7.68867 15.776 8.006 15.776C8.318 15.776 8.62667 15.6673 8.86733 15.4533L11.4327 13.3333H13.334C14.8047 13.3333 16.0007 12.1373 16.0007 10.6667V2.66667C16.0007 1.196 14.804 0 13.3333 0ZM4.66667 8C4.11467 8 3.66667 7.552 3.66667 7C3.66667 6.448 4.11467 6 4.66667 6C5.21867 6 5.66667 6.448 5.66667 7C5.66667 7.552 5.21867 8 4.66667 8ZM8 8C7.448 8 7 7.552 7 7C7 6.448 7.448 6 8 6C8.552 6 9 6.448 9 7C9 7.552 8.552 8 8 8ZM11.3333 8C10.7813 8 10.3333 7.552 10.3333 7C10.3333 6.448 10.7813 6 11.3333 6C11.8853 6 12.3333 6.448 12.3333 7C12.3333 7.552 11.8853 8 11.3333 8Z",
    fill: "#0049D4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4944_1865"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.f7ed9de15976b8ba2f462d93c7ca2226.svg";
export { ForwardRef as ReactComponent };